import { FC } from "react";


import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";

const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {

  return (
    <>
        <div className="phone-fax-holder text-start text-md-end" data-tour="sixth-step">
            <p className="mb-2"><i className="bi bi-telephone"></i> {PHONE_NUMBER}</p>
            <p className="m-0"><i className="bi bi-printer"></i> {FAX_NUMBER}</p>
        </div>
    </>
  );
};

export default ContactAndSafetyInfo;
